import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { catchError, retry, timeout } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { StampData } from '@app/models/StampData';
import { Utility } from '@app/models/utility';
import { environment } from 'src/environments/environment';
import { firstValueFrom, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ObcApiService {

  constructor(
    private http: HttpClient
  ) { }

  public async punchStamp(stampData: StampData): Promise<void> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        // 'X-Api-Version': '1.0.1',
        'X-Authorization-Token': environment.setting.ObcToken
      })
    };

    const body = this.buildRequestBody(stampData);

    try {
      await firstValueFrom(
        this.http.post(environment.setting.ObcUri, body, httpOptions).pipe(
          timeout(5000),
          retry(3),
          catchError((err: HttpErrorResponse) => {
            return throwError(() => new Error(`${err.status}: ${err.message}`));
          })
        )
      );
      // TODO response handling
    } catch (error) {
      console.error(error);
      throw error instanceof Error ? error : new Error(String(error));
    }
  }

  private buildRequestBody(stampData: StampData) {
    if (!stampData || !stampData.key || !stampData.placeId) {
      throw new Error('Stamp data is missing required fields.');
    }

    const parsedDate = Utility.createDateFromText(stampData.timeStamp);
    if (!parsedDate || Number.isNaN(parsedDate.getTime())) {
      throw new Error('Failed to parse stamp timestamp.');
    }

    const latitudeText = this.parseCoordinate(stampData.latitude);
    const longitudeText = this.parseCoordinate(stampData.longitude);

    return {
      key: stampData.key,
      placeId: stampData.placeId,
      kind: stampData.kind.toString(),
      timeStamp: parsedDate.toISOString(), // ISO 8601
      latitude: latitudeText,
      longtitude: longitudeText, // API expects "longtitude"
      accuracy: ''
    };
  }

  private parseCoordinate(value: number | null | undefined): string {
    if (value === null || value === undefined || Number.isNaN(value)) {
      return '';
    }
    return value.toString();
  }
}
